// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"48a6f064","551":"0698782f","776":"db567505","786":"63862e07","812":"0f31dcda"}[chunkId] + ".chunk.js";
};